<div class="checklist-container">
  <div class="mb-4">
    <a class="d-inline-block" [routerLink]="backLink" [queryParams]="backQueryParams">
			<h2 class="d-flex align-items-center gap-2 m-0 h3">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path
						d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
						fill="#9FA1A4" />
				</svg>
        <span class="title m-0">{{ checklist }}</span>
			</h2>
		</a>
  </div>

  @if (isLoading) {
    <div class="loading-wrapper d-flex justify-content-center align-items-center">
      <span class="spinner-border text-secondary"></span>
    </div>
  } @else {
    @if (hasNoResults) {
      <div class="empty-state-wrapper d-flex justify-content-center align-items-center">
        <app-empty-state></app-empty-state>
      </div>
    } @else {
      <app-checklist-table
        [sections]="checklistSections"
        [groups]="checklistGroups"
        (actionClicked)="onActionClicked($event)">
      </app-checklist-table>
    }
  }
</div>